// apps/web/src/lib/vendas/chave-nfe.ts — Fase 12, Plano 11 (UI-SPEC: long-text chave de acesso NF-e).
// Puro: a coluna "Chave" mostra os 8 primeiros e os 4 últimos dígitos; a chave completa vai para "Copiar chave"
// e para o detalhe da NF.
const TRACO = '—';
const PREFIXO = 8;
const SUFIXO = 4;

export function encurtarChaveNfe(chave: string | null | undefined): string {
  if (chave === null || chave === undefined) return TRACO;
  const limpa = chave.trim();
  if (limpa.length < PREFIXO + SUFIXO) return limpa;
  return `${limpa.slice(0, PREFIXO)}…${limpa.slice(-SUFIXO)}`;
}
